<template>
    <b-notification :closable="false" type="is-dark">
        <h3>PlanitEasy Connect</h3>
        <p>
            <strong>Laatste versie:</strong> v{{ connectVersion.version }} - {{ connectVersion.date }}
        </p>

        <a :href="connectVersion.download" v-if="connectVersion.download" class="button is-success" target="_blank">Download</a>
    </b-notification>
</template>

<script>
export default {
    name: 'ConnectDownload',

    computed: {
        connectVersion() {
            return this.$store.state.connect
        },
        env() {
            return this.$store.state.env
        }
    }
}
</script>